import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment'
import styled from 'styled-components'
import { Colors, Button } from 'advenio-components'
import { ADD_ACTIVITY } from '../../Constants'
import ImageViewer from './ImageViewer'
import ActivityTableCell from '../ActivityTableCell'
import LoadingSpinner from '../LoadingSpinner'
import ChildrenActions, { Selectors as ParentChildSelectors } from '../../Data/Redux/ParentPlatform/ChildrenRedux'

const TableHeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 100%;
  background-color: ${Colors.gray500};
  color: ${Colors.white300};
  font-weight: bold;
`
const AddActivityContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 16px 0;

  @media (max-width:767px) {
    display: none;
  }
`
const ViewMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 16px 0;
`
const AddActivityButton = styled(Button)`
  height: 42px;
  margin-right: 16px;
  padding: 10px 16px;
  font-size: 12px;

  @media (max-width:1200px) {
    height: 32px;
    width: 120px;
    margin-right: 8px;
    padding: 4px 8px;
  }
`
const AddCheckInButton = styled(Button)`
  flex: 1;
  height: 42px;
  margin: 16px 0;
  font-size: 12px;
  padding: 10px 16px;

  @media (max-width:1200px) {
    width: 120px;
    height: 32px;
    margin: 8px;
    padding: 4px 8px;
  }
`
const AddCheckInContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  @media (min-width:768px) {
    justify-content: flex-end;
    margin: 8px;

    div {
      width: 300px;
    }
  }
`
const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  opacity: .4;
`
const LoadMoreContainer = styled.div`
  text-align: center;
  margin: 15px 0;
`
const ButtonLoadMore = styled(Button)`
  font-size: 14px;
  height: 35px;
  padding: 0px 15px;
`

class RecentActivity extends Component {
  state = {
    image: null,
    openViewer: false,
  }

  componentWillMount() {
    const {
      getStudentActivitiesViaParent,
      loading,
      student,
    } = this.props

    if (!loading && student &&
      (!student.recent_activities || student.recent_activities.length <= 0)
    ) {
      getStudentActivitiesViaParent(student.id)
    }
  }

  deleteActivity = activityId => this.props.onDeleteActivity(activityId)

  handleOpenViewer = image => this.setState({ image, openViewer: true })

  closeViewer = () => this.setState({ openViewer: false })

  loadPreviousActivities = () => {
    const { getStudentActivitiesViaParent, student } = this.props
    const last_day_index = student.recent_activities.length - 1
    const previous_date = {
      date: student.recent_activities[last_day_index].previous_date,
    }

    getStudentActivitiesViaParent(student.id, previous_date)
  }

  renderTable = () => {
    const activities = this.props.student.recent_activities

    if (activities && activities.length > 0) {
      return (
        <div>
          { activities.map(day => (
            <div key={day.date}>
              <TableHeaderContainer>
                <span>{moment(day.date).format('DD MMMM YYYY')}</span>
              </TableHeaderContainer>
              {day.activities.map((activity, index) => (
                <ActivityTableCell
                  key={`${activity.activity_id}-${activity.type}-${moment(activity.date).unix()}`}
                  index={index}
                  registered_by={activity.registered_by}
                  onDeleteActivity={this.deleteActivity}
                  onPhotoClick={this.handleOpenViewer}
                  onCloseViewer={this.closeViewer}
                  parent={this.props.parent}
                  user={this.props.user}
                  alone={index === 0 && day.activities.length === 1}
                  top={index === 0}
                  bottom={index === (day.activities.length - 1)}
                  {...activity}
                />
              ))}
            </div>
          ))}

          {activities[activities.length - 1].previous_date &&
            activities[activities.length - 1].previous_date !== null &&
            <LoadMoreContainer>
              <ButtonLoadMore
                success
                onClick={() => this.loadPreviousActivities()}
                loading={this.props.loading}
              >
                Cargar más
              </ButtonLoadMore>
            </LoadMoreContainer>
          }
        </div>
      )
    }

    return (
      <div>
        <TableHeaderContainer>
          <span>{moment().format('DD MMMM YYYY')}</span>
        </TableHeaderContainer>
        <EmptyState>
          No hay actividad reciente
        </EmptyState>
      </div>
    )
  }

  render() {
    const {
      isDisenrolled,
      loading,
      onCheckIn,
      onHealthCheck,
      onNewActivityClick,
      parent,
      student,
      disableAddHomeReport,
    } = this.props
    const {
      openViewer,
      image,
    } = this.state

    if (loading && student.recent_activities && student.recent_activities.length === 0) return <LoadingSpinner />

    return (
      <div>
        {!parent && <AddActivityContainer>
          <AddActivityButton
            primary
            small
            onClick={student.checkin.id ? onNewActivityClick : onHealthCheck}
            disabled={Boolean(isDisenrolled)}
          >
            {student.checkin.id ? ADD_ACTIVITY : 'Check In'}
          </AddActivityButton>
        </AddActivityContainer>}
        {parent && (
          <AddCheckInContainer>
            <div>
              <AddCheckInButton
                ghost
                fullWidth
                onClick={onCheckIn}
                disabled={
                  Boolean(isDisenrolled) ||
                  student.home_report !== null ||
                  Boolean(disableAddHomeReport)
                }
              >
                Agregar formato de entrada
              </AddCheckInButton>
            </div>
          </AddCheckInContainer>
        )}
        {this.renderTable()}
        <ImageViewer open={openViewer} img={image} onClose={this.closeViewer} />
      </div>
    )
  }
}

RecentActivity.propTypes = {
  /** The ID of the active child/student */
  activeChildId: PropTypes.number,
  /** Flag marking whether the current student is not enrolled */
  isDisenrolled: PropTypes.bool,
  /** Page loading flag */
  loading: PropTypes.bool.isRequired,
  /** Flag marking whether the current user is a parent */
  parent: PropTypes.bool,
  /** The active child/student */
  student: PropTypes.object,
  /** Button disabled status to open modal: "Agregar Formato de Entrada" */
  disableAddHomeReport: PropTypes.bool,

  /** Fetch all activities registered for the current student */
  getStudentActivitiesViaParent: PropTypes.func.isRequired,
  /** Callback function to be fired after checking in a student */
  onCheckIn: PropTypes.func,
  /** Callback function to be fired when deleting an activity */
  onDeleteActivity: PropTypes.func,
  /** Callback function to be fired when submitting a new health check to the API */
  onHealthCheck: PropTypes.func,
  /** Callback function to be fired when creating an activity */
  onNewActivityClick: PropTypes.func,
}

RecentActivity.defaultProps = {
  activeChildId: null,
  isDisenrolled: false,
  parent: false,
  student: {},
  disableAddHomeReport: false,
  onCheckIn: () => { },
  onDeleteActivity: () => { },
  onHealthCheck: () => { },
  onNewActivityClick: () => { },
}

const mapStateToProps = state => ({
  activeChildId: state.parent_platform_children.activeChildId,
  loading: state.parent_platform_children.get.fetching,
  student: ParentChildSelectors.activeChild(state) &&
    ParentChildSelectors.activeChild(state).student,
  user: state.auth.user,

})

const mapDispatchToProps = dispatch => ({
  getStudentActivitiesViaParent: (studentId, query) =>
    dispatch(ChildrenActions.getActivitiesRequest(studentId, query)),
})

export default connect(mapStateToProps, mapDispatchToProps)(RecentActivity)



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/RecentActivity.jsx